import Warning from '@mui/icons-material/Warning';

import { useCommandBarAllValues } from '#components/command-bar/command-bar-context.js';
import { useCommandBarStore } from '#components/command-bar/command-bar-store.js';
import { DESIGN_SEARCH_PREFIX, DESIGN_SEARCH_PROVIDER_ID } from './design-search-types.js';

export function DesignSearchEmptyMessage() {
	const search = useCommandBarStore((s) => s.search);
	const providers = useCommandBarAllValues('providers');

	const shouldShow = search.startsWith(DESIGN_SEARCH_PREFIX);
	const isProviderAvailable = providers.some((p) => p.id === DESIGN_SEARCH_PROVIDER_ID);

	if (!shouldShow) {
		return null;
	}

	if (!isProviderAvailable) {
		return (
			<span className='flex items-center gap-2 text-amber-a12'>
				<Warning className='text-amber-10' />
				Design search is not available on this page
			</span>
		);
	}

	return 'Enter a design name to search designs';
}
